import { render, staticRenderFns } from "./SalMonth.vue?vue&type=template&id=4d88fa89&scoped=true&"
import script from "./SalMonth.vue?vue&type=script&lang=js&"
export * from "./SalMonth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d88fa89",
  null
  
)

export default component.exports